import {
  setCookie,
  getCookie,
  delCookie
} from '@/utils/cookieUtils';

var storage = {

    //设置token
    setToken(data) {
        sessionStorage.setItem('token', data);
        setCookie('token', data, 604800);
    },
    //获取token
    getToken() {
        //return sessionStorage.getItem('token');
        return getCookie('token');
    },
    //设置用户信息
    setUserInfo(data) {
        sessionStorage.setItem('userInfo', data);
        setCookie('userInfo', data, 604800);
    },
    //获取用户信息
    getUserInfo() {
        //return sessionStorage.getItem('userInfo');
        return getCookie('userInfo');
    },
    //设置账号信息
    setAccountInfo(data) {
        data = JSON.stringify(data);
        sessionStorage.setItem('accountInfo', data);
    },
    //获取账号信息
    getAccountInfo() {
        return JSON.parse(sessionStorage.getItem('accountInfo'));
    },
    //删除账号信息
    reMoveAccountInfo() {
        return sessionStorage.removeItem('accountInfo');
    },
    //设置当前地址信息
    setCurrentLocation(data) {
        sessionStorage.setItem('currentLocation', JSON.stringify(data));
    },
    //获取当前地址信息
    getCurrentLocation() {
        let defaultValue = {
            "accuracy": null,
            "altitude": null,
            "altitudeAccuracy": null,
            "heading": null,
            "latitude": "22.52231467",
            "longitude": "113.39942236",
            "speed": null,
            "timestamp": null,
            "point": {
                "lng": 113.39942236,
                "lat": 22.52231467,
                "of": "inner"
            },
            "address": {
                "city": "中山市",
                "city_code": 0,
                "district": "",
                "province": "广东省",
                "street": "",
                "street_number": ""
            },
            "selectAddress": "中山市"
        };
        return JSON.parse(sessionStorage.getItem('currentLocation')) || defaultValue;
    },
    //设置历史记录
    setHistoryInfo(data) {
        sessionStorage.setItem('history', JSON.stringify(data));
    },
    //获取历史记录
    getHistoryInfo() {
        return JSON.parse(sessionStorage.getItem('history'));
    },
    //删除历史记录
    reMoveHistoryInfo() {
        return sessionStorage.removeItem('history');
    },
    //设置场地方财务流水id
    setFlowId(data) {
        sessionStorage.setItem('FlowId', data);
    },
    //获取场地方财务流水id
    getFlowId() {
        return sessionStorage.getItem('FlowId');
    },
    //设置code
    setCode(data) {
        sessionStorage.setItem('code', data);
    },
    //获取code
    getCode() {
        return sessionStorage.getItem('code') || "";
    },
}

//导出
export default storage


// WEBPACK FOOTER //
// ./src/utils/storage.js